async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== "") search.set(key, String(value));
  });
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchVehicleFairValueDashboard(params = {}) {
  return requestJson(`/api/admin/mobility/vehicle-fair-value${buildQuery(params)}`);
}

export async function fetchVehicleValuationDiagnostics() {
  return requestJson("/api/admin/mobility/vehicle-valuation-diagnostics");
}

export async function recalculateListingFairValue(listingId) {
  return requestJson(
    `/api/admin/mobility/vehicle-listings/${encodeURIComponent(listingId)}/recalculate-fair-value`,
    { method: "POST" }
  );
}

export async function recalculateAllFairValue(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-fair-value/recalculate${buildQuery(params)}`,
    { method: "POST", body: JSON.stringify({ limit: params.limit }) }
  );
}
